import { render, staticRenderFns } from "./StockLinkedPurchaseOrdersTable.vue?vue&type=template&id=951b798e&scoped=true"
import script from "./StockLinkedPurchaseOrdersTable.vue?vue&type=script&lang=js"
export * from "./StockLinkedPurchaseOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./StockLinkedPurchaseOrdersTable.vue?vue&type=style&index=0&id=951b798e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951b798e",
  null
  
)

export default component.exports